var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 17.6471,
    rx: 3.6,
    fill: "#2D2D2D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3039 8.82351C16.3039 10.7273 15.4007 12.4246 13.998 13.5198C15.054 14.3427 16.3629 14.7996 17.7216 14.7996C21.044 14.7996 23.7469 12.1187 23.7469 8.82351C23.7469 5.52829 21.044 2.84741 17.7216 2.84741C16.3629 2.84741 15.054 3.30434 14.0001 4.12552C15.4006 5.22231 16.3039 6.91973 16.3039 8.82351Z",
    fill: "#FFCD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3045 8.82351C16.3045 6.91973 15.4012 5.22231 13.9987 4.12721C12.9735 3.32677 11.6821 2.84741 10.2792 2.84741C6.95686 2.84741 4.25391 5.52829 4.25391 8.82351C4.25391 12.1187 6.95686 14.7996 10.2792 14.7996C11.6821 14.7996 12.9735 14.3202 13.9987 13.5198C15.4013 12.4246 16.3045 10.7273 16.3045 8.82351Z",
    fill: "#FF5023"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.25a6fe9c09e1b9e7d0f8e3ec4215c282.svg";
export { ForwardRef as ReactComponent };